import * as tslib_1 from "tslib";
import { CartActions } from '@wix/wixstores-client-core/dist/es/src/cart-actions/cartActions';
import { ProductOptionsService } from './products/productOptionsService';
import { validateUserInputs, formatCustomTextFields } from './products/producUtils';
import { getProductBySlug, getDefaultProduct, gqlQuery } from './getProduct';
import { PageMap } from '@wix/wixstores-client-core/dist/es/src/constants';
import { query as getPrevNextProductsQuery } from '../graphql/getPrevNextProducts.graphql';
import * as _ from 'lodash';
var ProductService = /** @class */ (function () {
    function ProductService(siteStore, pubSubManager) {
        this.siteStore = siteStore;
        this.cartActions = new CartActions(this.siteStore, pubSubManager, 'wixcode', PageMap.CART);
    }
    ProductService.prototype.updateOptions = function (product) {
        this.product = product;
        this.options = new ProductOptionsService(product);
    };
    ProductService.prototype.getProductBySlug = function (slug, externalId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getProductBySlug(this.siteStore, slug, externalId)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    ProductService.prototype.getDefaultProduct = function (externalId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getDefaultProduct(this.siteStore, externalId)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    ProductService.prototype.validate = function (userInputs) {
        return validateUserInputs(this.product, userInputs);
    };
    ProductService.prototype.getNextPrevProducts = function (categoryId, createVersion) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var variables, res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        variables = {
                            createVersion: String(createVersion),
                            categoryId: categoryId,
                        };
                        return [4 /*yield*/, gqlQuery(this.siteStore, getPrevNextProductsQuery, variables, "getNextPrevProducts" /* GetNextPrevProducts */)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, {
                                next: _.get(res, 'data.catalog.next.list.0.urlPart', null),
                                prev: _.get(res, 'data.catalog.prev.list.0.urlPart', null),
                            }];
                }
            });
        });
    };
    ProductService.prototype.shouldNavigateToCart = function () {
        return this.cartActions.shouldNavigateToCart();
    };
    ProductService.prototype.addToCart = function (product, userInputs, shouldOpenCart) {
        if (shouldOpenCart === void 0) { shouldOpenCart = true; }
        var customTextFields = formatCustomTextFields(product, userInputs);
        var selectionIds = userInputs.selection.map(function (s) { return s.id; });
        var quantity = userInputs.quantity[0];
        return this.cartActions.addToCart(product.id, selectionIds, quantity, customTextFields, shouldOpenCart);
    };
    return ProductService;
}());
export { ProductService };
//# sourceMappingURL=productService.js.map